<template>
  <div id="footer" class="container-fluid">
    <div class="pc-container">
      <div class="footer-left">
        <div class="footer-left-top">
          <img src="../assets/img/bottom1.png" alt="">
          <img src="../assets/img/bottom2.png" alt="">
          <img src="../assets/img/bottom3.png" alt="">
          <img src="../assets/img/bottom4.png" alt="">
        </div>
        <div class="footer-left-bottom">
          <p>主办单位:清水县文化馆</p>
          <p color="white"><a href="https://beian.miit.gov.cn/#/Integrated/index" color="white" target="_blank">ICP备案/许可证号：陇ICP备2022002096号</a></p>
        </div>
      </div>
      <div class="footer-right">
        <div class="erweima">
          <img src="../assets/img/qspc.png" alt="">
          <p>扫码打开清水县文化馆</p>
        </div>
        <div class="erweima">
          <img src="../assets/img/qsh5.png" alt="">
          <p>扫码打开清水文化云</p>
        </div>
        <!-- <div class="erweima">
          <img src="../assets/img/erweima.png" alt="">
          <p>扫描关注“清水文化”</p>
        </div> -->
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Footer",
  data() {
    return {};
  }
};
</script>
<style scoped>
.pc-container{
  width: 1200px;
  margin: 0 auto;
}
#footer{
  width: 100%;
  height: 470px;
  color: #fff;
  background: #B34F2C;
  overflow: hidden; 
  margin-top: 120px;
}
#footer .pc-container{
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: row;
  height: 470px;
}
.footer-left{
  flex: 1;
}
.footer-left .footer-left-top{
  width: 474px;
  border-bottom: 1px solid #fff;
  padding-bottom: 22px;
  margin-bottom: 22px;
  display: flex;
}
.footer-left .footer-left-top img{
  height: 55px;
  margin-right: 25px;
}
.footer-left .footer-left-bottom{
  font-size: 16px;
  color: #fff;
  line-height: 17px;
}
.footer-right{
  flex: 1;
  display: flex;
}
.footer-right .erweima{
  width: 158px;
  height: 200px;
  text-align: center;
  background: #fff;
  margin-left: 46px;
}
.footer-right .erweima:first-child{
  margin-left: 0;
}
.footer-right .erweima img{
  width: 130px;
  height: 130px;
  margin: 0 auto;
  margin-top: 10px;
  margin-bottom: 10px;
}
.footer-right .erweima p{
  font-size: 13.5px;
  color: #000;
}
a:link{
	color: #fff;
}
a:visited{
	color: #fff;
}
a:hover{
	color: #fff;
}
a:active{
	color: #fff;
}


</style>




// WEBPACK FOOTER //
// src/components/Footer.vue